module.exports = __webpack_public_path__ + "img/app_phone2.385e2cca.png";